<template>

			<div class="content">
		        <div class="container-fluid">
		        	<div class="row">
			            <div class="col-md-12">
			              <div class="card">
			                <div class="card-header card-header-info">
			                  <h4 class="card-title ">Tambah Area</h4>
							</div>
			                <div class="card-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="form-group">
                                                <label class="bmd-label-floating">Nama Area</label>
                                                <input type="text" class="form-control" placeholder="Nama Area..." v-model="tambah.form.nama">
                                            </div>
                                        </div>
                                    </div>
                                </div>
			                    <div class="row">
			                      <div class="col-md-12">
			                        <div class="form-group">
                                        <button class="btn btn-primary" @click="tambah.submit">Simpan</button>
			                        </div>
			                      </div>
			                    </div>
			                </div>
			              </div>
			            </div>
		        	</div>
		    	</div>
		    </div>
</template>

<script>

import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'

// use the APIs
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 

var numeral = require("numeral");

Vue.use(moment)

export default {
	components: { 
		vuejsDatepicker,
		moment,
	}, 
	setup() {
		const tambah = { 
			form: reactive({
				nama: ""
			}),
			submit() {
				var data = new FormData();
				data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
				data.append('nama', tambah.form.nama);
				
				var apiUrl = 'TambahArea';
				
				myGlobal.call(data,apiUrl).then(x => {
					//myGlobal.loger(x);
					if (x.status) {
						location.href="#/setting/area"
					} else {
						alert(x.pesan);
					}
				})
			}
		}

		return {
			tambah,
			myGlobal
		}
  	},
	mounted() {

	}
	/*
  	data() {
		return {
			title: "Detail Servis",
            nama: '', 
		}
	},
	methods: {
        Simpan() {
			var data = new FormData();
            data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
            data.append('nama', this.nama);
			
            var apiUrl = 'TambahArea';
            
			this.PostData(data,apiUrl).then(x => {
				this.loger(x);
				if (x.status) {
                    location.href="#/area"
				} else {
				    alert(x.pesan);
				}
			})
        }
	}
	*/
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/setting/area-tambah.vue